import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Textarea } from "@opendate-app/setlist";

const GiftCardReactivateModal = ({ giftCard, submitting, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  const footer = (
    <div className="gift-card-modal-footer">
      <Button variant="secondary" onClick={onClose} disabled={submitting}>
        Cancel
      </Button>
      <Button variant="primary" disabled={submitting || !reason.trim()} onClick={() => onSubmit({ reason })}>
        Reactivate card
      </Button>
    </div>
  );

  return (
    <Modal
      open
      onClose={onClose}
      icon={false}
      title={`Reactivate gift card •••• ${giftCard.last4}`}
      description="The card works again with the balance it had when it was voided."
      footer={footer}
    >
      <Textarea
        label="Reason"
        rows={3}
        placeholder="Why is this card being reactivated?"
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
    </Modal>
  );
};

GiftCardReactivateModal.propTypes = {
  giftCard: PropTypes.shape({
    last4: PropTypes.string.isRequired,
  }).isRequired,
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

GiftCardReactivateModal.defaultProps = {
  submitting: false,
};

export default GiftCardReactivateModal;
